module.exports = __webpack_public_path__ + "img/UTFLIG-5.3d04ebc0.jpg";